import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data';

import { ANALYTICS_SOURCE } from '../constants';

export const useWithButtonAnalytics = ({
	actionSubjectId,
	renderLocation,
	contentId,
	contentType,
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { edition } = useSessionData();
	const sendButtonUIEvent = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				source: ANALYTICS_SOURCE,
				actionSubjectId,
				objectId: contentId,
				attributes: {
					edition,
					location: renderLocation,
					contentType,
				},
			},
		}).fire();
	};

	return {
		sendButtonUIEvent,
	};
};

export const useWithShareTokenButtonAnalytics = ({
	actionSubjectId,
	location,
	shareToken,
	contentType,
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { edition } = useSessionData();
	const sendButtonUIEvent = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				source: ANALYTICS_SOURCE,
				actionSubjectId,
				objectId: shareToken,
				attributes: {
					edition,
					location,
					contentType,
				},
			},
		}).fire();
	};

	return {
		sendButtonUIEvent,
	};
};
